module.exports = __webpack_public_path__ + "img/Pic_GYY_Girl1.c163aa50.png";